import LockIcon from "@mui/icons-material/Lock";
import { Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import React, { useMemo } from "react";
import theme from "../../../styles/theme.ts";
import { getChartConfig } from "../../charts/getChartConfig.ts";
import IconContained from "../../customicons/IconContained.tsx";
import DemographicChart from "./DemographicChart.tsx";

export default function DemographicBreakdown({
  data,
  version,
}: {
  data: Partial<DeviceSearchResponse>;
  version?: string;
}) {
  const { genders, ethnicities, ages, races } = data;
  const gendersConfig = useMemo(() => getChartConfig(genders ?? []), [genders]);
  const ethnicitiesConfig = useMemo(
    () => getChartConfig(ethnicities ?? []),
    [ethnicities],
  );
  const agesConfig = useMemo(() => getChartConfig(ages ?? []), [ages]);
  const racesConfig = useMemo(() => getChartConfig(races ?? []), [races]);

  return (
    <div
      id={"demographic-breakdown"}
      className="demographic-breakdown-container"
    >
      <Typography variant="h6" align="left" gutterBottom>
        Demographic Breakdown
      </Typography>
      <div
        className={`${version === "Preview Mode" ? "preview-mode-charts" : ""}`}
      >
        <Grid container spacing={3}>
          <DemographicChart title="Gender" config={gendersConfig} />
          <DemographicChart title="Ethnicity" config={ethnicitiesConfig} />
          <DemographicChart
            title="Age"
            chartClass="chart-container-lg"
            config={agesConfig}
          />
          <DemographicChart
            title="Race"
            chartClass="chart-container-lg"
            config={racesConfig}
          />
        </Grid>
        {version && version === "Preview Mode" && (
          <div className="preview-mode-backdrop">
            <IconContained
              icon={<LockIcon />}
              sx={{
                backgroundColor: theme.palette.primary.light,
                color: "white",
              }}
            />
            <Typography variant="h6">
              Unlock more patient data with 3Aware Premium
            </Typography>
            <Typography variant="body1" sx={{ color: grey[500] }}>
              Full access to patient demographics and geographic locations,
              patient level details with clinical notes and advanced analytic
              tools powered by artificial intelligence.
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
}
